export default function Listen() {
    return (
        <div className="relative" id="transformations">
            <div className="max-w-7xl mx-auto py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h2 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl">
                        Luister naar hun verhaal
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-12">
                        <div className="col-span-1 px-8 md:px-0">
                            <video
                                src="/assets/13-kilo-kwijt.mp4#t=0.1"
                                controls
                                loop
                                preload="metadata"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="col-span-1 px-8 md:px-0">
                            <video
                                src="/assets/15-kilo-kwijt.mp4#t=0.1"
                                controls
                                loop
                                preload="metadata"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="col-span-1 px-8 md:px-0">
                            <video
                                src="/assets/20-kilo-kwijt.mp4#t=0.1"
                                controls
                                loop
                                preload="metadata"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                    <div className="text-center mt-12">
                        <a
                            href="/verhalen"
                            className="inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-black hover:text-white bg-we-are-yellow hover:bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Bekijk alle succesverhalen
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
